// extracted by mini-css-extract-plugin
export var chevronIcon = "_an-2";
export var teamName = "_an-1";
export var teamSwitcherButton = "_an-0";